var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 2.89474C18 4.49346 16.7408 5.78947 15.1875 5.78947C14.3933 5.78947 13.676 5.45069 13.1646 4.90588L5.44 9.96528C5.55952 10.2866 5.625 10.6354 5.625 11C5.625 11.5396 5.48153 12.0448 5.23171 12.4772L12.8628 17.4754C13.3692 16.7118 14.2215 16.2105 15.1875 16.2105C16.7408 16.2105 18 17.5065 18 19.1053C18 20.704 16.7408 22 15.1875 22C13.6342 22 12.375 20.704 12.375 19.1053C12.375 18.9192 12.3921 18.7372 12.4247 18.5609L4.4615 13.3452C3.99821 13.6909 3.42848 13.8947 2.8125 13.8947C1.2592 13.8947 0 12.5987 0 11C0 9.40128 1.2592 8.10526 2.8125 8.10526C3.60666 8.10526 4.32394 8.44404 4.83536 8.98884L12.56 3.92943C12.4405 3.60813 12.375 3.2593 12.375 2.89474C12.375 1.29602 13.6342 0 15.1875 0C16.7408 0 18 1.29602 18 2.89474Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.49059678b18b8225b6f630a81ef2166b.svg";
export { ForwardRef as ReactComponent };